<div class="ofwca-list-container">
  <table mat-table [dataSource]="ofwcasDataSource">

    <!-- Position Column -->
    <ng-container matColumnDef="fullName">
      <th mat-header-cell *matHeaderCellDef> Imię i nazwisko</th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="!disableLinks" class="default-link" [routerLink]="['/ofwca/szczegoly', element.uuid]">
          {{element.firstName}} {{element.lastName}}
        </a>
        <ng-container *ngIf="disableLinks">
          {{element.firstName}} {{element.lastName}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="pesel">
      <th mat-header-cell *matHeaderCellDef> PESEL</th>
      <td mat-cell *matCellDef="let element">
        {{element.pesel}}
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email</th>
      <td mat-cell *matCellDef="let element">
        <div *ngFor="let email of element.emails">
          <span *ngIf="email.main ">{{email.address}}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef> Numer telefonu</th>
      <td mat-cell *matCellDef="let element">
        <div *ngFor="let phone of element.phones">
          <span *ngIf="phone.main">{{phone.number | phone}}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="ASF360">
      <th mat-header-cell *matHeaderCellDef> Konto ASF360 </th>
      <td mat-cell *matCellDef="let element" class="center-cell">
        <button *ngIf="element.user360?.length > 0" mat-icon-button>
          <mat-icon class="positive-icon">check_circle</mat-icon>
        </button>
        <button *ngIf="!element.user360 || element.user360.length === 0" mat-icon-button>
          <mat-icon class="negative-icon">cancel</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef> Aktywna </th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [disabled]="!(userPermissions | async).ofwca.write || updateInProgress"
          [checked]="element.activeUnderPartnersIds.includes(partnerObject.uuid)" (change)="formChanged(
            $event,
            element,
            {active: $event.checked, partner: partnerObject.uuid}
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="facility">
      <th mat-header-cell *matHeaderCellDef> Placówka</th>
      <td mat-cell *matCellDef="let element">
        {{element.facility?.address?.searchString}}
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a
          *ngIf="!disableLinks"
          class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]"
        >{{element.partner?.shortName}}</a>
        <ng-container *ngIf="disableLinks">
          {{element.partner?.shortName}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) OFWCA  </th>
      <td mat-cell *matCellDef="let element">
        {{element.assetsRegional?.firstName}} {{element.assetsRegional?.lastName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="competitionRequirementsMet">
      <th mat-header-cell *matHeaderCellDef> IDD konkursy </th>
      <td mat-cell *matCellDef="let element" class="center-cell">
        <button *ngIf="element.competitionRequirementsMet" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        <button *ngIf="!element.competitionRequirementsMet" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).ofwca.delete || disableLinks" mat-menu-item (click)="deleteOfwca(element)">Usuń</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
</div>
